<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import ContainersManagementTable from '@components/tables/containers-management-table.vue'
import { httpServices } from '@utils/http-services'
import { permissionsService } from '@utils/permissions'

export default {
  page: {
    title: 'Container Management',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, ContainersManagementTable },
  data() {
    return {
      isVanishedAdmin: permissionsService.isVanishedAdmin(),
      containers: null,
      groups: null,
      fleetStatus: null,
      showAll: this.$auth.user.profile.permissions.organization === 'vanished',
    }
  },
  mounted() {
    this.getContainers()
    this.getGroups()
  },
  methods: {
    onDeleteContainer(record) {
      const id = record.pk.replace('CONTAINER#', '')
      httpServices.deleteContainer(id, record.orgId).then(
        (res) => {
          this.$notification.success({
            message: `Container Deleted`,
          })
          this.getContainers()
        },
        () => {
          this.$notification.error({
            message: `Failed to Delete`,
          })
        }
      )
    },
    startFleets() {
      httpServices.startFleets()
    },
    stopFleets() {
      httpServices.stopFleets()
    },
    createContainer() {
      this.$router.push({
        name: 'create-container',
      })
    },
    getGroups() {
      httpServices.getGroups().then((res) => {
        this.groups = res
      })
    },
    getContainers() {
      httpServices
        .getFleetStatus()
        .then((res) => {
          this.fleetStatus = res
        })
        .then(() => {
          httpServices.getContainers().then((res) => {
            this.containers = res
            this.containers.forEach((c) => {
              const state = this.fleetStatus?.filter(
                (f) => f?.bonfireId === c?.bonfireId
              )
              c.state = state[0]?.State
            })
          })
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div id="containers--container" class="ant-row">
      <div class="header">
        <h4>
          <a-icon type="code" style="padding-right: 8px" />
          Containers
        </h4>
        <div>
          <a-button
            v-if="isVanishedAdmin"
            style="margin-right: 1rem"
            type="primary"
            icon="play-circle"
            @click="startFleets"
            >Start All
          </a-button>
          <a-button
            v-if="isVanishedAdmin"
            style="margin-right: 1rem"
            type="danger"
            icon="pause-circle"
            @click="stopFleets"
            >Stop All
          </a-button>
          <a-button type="ghost" icon="plus-circle" @click="createContainer"
            >Add New
          </a-button>
        </div>
      </div>
      <a-card style="width: 100%; margin-top: 0">
        <div v-if="!containers || !groups" class="loader--container">
          <a-icon
            type="loading"
            style="padding-left: 8px; font-size: 24px; color: #1890ff"
            spin
          />
        </div>
        <div v-else>
          <ContainersManagementTable
            :groups="groups"
            :containers="containers"
            @deleteContainer="onDeleteContainer"
          ></ContainersManagementTable>
        </div>
      </a-card>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

#containers--container {
  position: relative;
  width: 100%;
  padding: 16px;
  margin: 0 0 16px;
  background: white;
  border: 1px solid #ebedf0;
  box-shadow: 4px 8px 24px 5px rgb(208 216 243 / 60%);
  transition: all 0.2s;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem;
    margin-bottom: 0;
    text-align: left;
    background: #141414;
    border-radius: 4px 4px 0 0;

    h4 {
      margin: 0;
      font-weight: 100;
      color: white;
    }
  }

  .ant-card {
    margin: 1.6rem auto;

    .ant-card-head-title {
      font-weight: 700;
    }
  }

  table tr td {
    text-transform: capitalize;
  }
}
</style>
